import classNames from "classnames";
import styles from "./consultBox.module.scss";

export default function ConsultPopupSuccess({ onClose }) {
    return (
        <div
            id={styles["popup-success"]}
            className="sapo-modal register-modal register-success-modal show"
            style={{ display: "block" }}
        >
            <div className="sapo-modal-dialog">
                <div className="sapo-modal-content">
                    <div className={classNames(styles["fix-body"], "sapo-modal-body")}>
                        <button
                            type="button"
                            className={classNames(styles["cursor-pointer"], "btn-close")}
                            aria-label="Close"
                            onClick={onClose}
                        >
                            <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.666 10.668L21.3327 21.3346"
                                    stroke="#AEAEAE"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                ></path>
                                <path
                                    d="M21.3327 10.668L10.666 21.3346L21.3327 10.668Z"
                                    fill="#AEAEAE"
                                ></path>
                                <path
                                    d="M21.3327 10.668L10.666 21.3346"
                                    stroke="#AEAEAE"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                ></path>
                            </svg>
                        </button>

                        <div className={classNames(styles["fix-margin-logo"], "logo")}>
                            <img
                                src="https://www.sapo.vn/Themes/Portal/Default/StylesV2/images/logo/Sapo-logo.svg?v=202101071107"
                                alt="Sapo logo"
                            />
                        </div>
                        <div className="content">
                            <svg
                                className={classNames(styles["fix-icon-success"], "icon-success")}
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fillRule="evenodd"
                                clipRule="evenodd"
                            >
                                <path d="M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Zm0,1A11,11,0,1,1,1,12,11,11,0,0,1,12,1Zm7,7.46L10,18,5,12.16l.76-.65,4.27,5,8.24-8.75Z"></path>
                            </svg>
                            <div className={classNames(styles["fix-block-title"], "block-title")}>
                                <h2>Đăng ký thành công</h2>
                            </div>
                            <p>
                                Chuyên viên tư vấn Sapo sẽ liên hệ với quý khách trong thời gian sớm nhất
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
